export class GeoLocation {
  private static getLocationInfo() {
    const request = new XMLHttpRequest();
    request.open('GET', 'https://free.freeipapi.com/api/json', false);
    request.send();
    if (request.status !== 200) {
      return null;
    } else {
      return JSON.parse(request.responseText);
    }
  }

  static getCountryCode() {
    const locationObj = this.getLocationInfo();
    if (locationObj) {
      return locationObj.countryCode;
    } else {
      return '';
    }
  }
}
